var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uni-home" },
    [
      _c("div", { staticClass: "item-box user-info" }, [
        _c("div", { staticClass: "student-info" }, [
          _c("div", { staticClass: "head-img-box" }, [
            _vm.studentInfo.thumb
              ? _c("img", {
                  staticClass: "img",
                  attrs: { src: _vm.studentInfo.thumb, alt: "暂无头像" },
                })
              : _c("img", {
                  staticClass: "img",
                  attrs: {
                    src: require("@/assets/images/headEmpty.png"),
                    alt: "暂无头像",
                  },
                }),
          ]),
          _c("div", { staticClass: "student-content" }, [
            _c("p", { staticClass: "name" }, [
              _vm._v(
                _vm._s(_vm._f("isEmpty")(_vm.studentInfo.title)) + "，欢迎您！"
              ),
            ]),
            _c("ul", { staticClass: "info-list mat10" }, [
              _c("li", { staticClass: "item" }, [
                _vm._m(0),
                _c("span", { staticClass: "con" }, [
                  _vm._v(_vm._s(_vm.studentInfo.title)),
                ]),
              ]),
              _vm._ENTRANCETYPE === "adult"
                ? _c("li", { staticClass: "item" }, [
                    _c("span", { staticClass: "tit" }, [_vm._v("考生号： ")]),
                    _c("span", { staticClass: "con" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("isEmpty")(_vm.studentInfo.candidate_number)
                        )
                      ),
                    ]),
                  ])
                : _c("li", { staticClass: "item" }, [
                    _c("span", { staticClass: "tit" }, [_vm._v("准考证号： ")]),
                    _c("span", { staticClass: "con" }, [
                      _vm._v(
                        _vm._s(_vm._f("isEmpty")(_vm.studentInfo.exam_number))
                      ),
                    ]),
                  ]),
              _c("li", { staticClass: "item" }, [
                _c("span", { staticClass: "tit" }, [_vm._v("身份证号：")]),
                _c("span", { staticClass: "con" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("isEmpty")(
                        _vm._f("setCard")(_vm.studentInfo.identity)
                      )
                    )
                  ),
                ]),
              ]),
              _c("li", { staticClass: "item" }, [
                _c("span", { staticClass: "tit" }, [_vm._v("报考类别：")]),
                _c("span", { staticClass: "con" }, [
                  _vm._v(_vm._s(_vm._f("isEmpty")(_vm.studentInfo.education))),
                ]),
              ]),
              _c("li", { staticClass: "item" }, [
                _vm._m(1),
                _c("span", { staticClass: "con" }, [
                  _vm._v(
                    _vm._s(_vm._f("isEmpty")(_vm.studentInfo.profession_level))
                  ),
                ]),
              ]),
              _c("li", { staticClass: "item" }, [
                _vm._m(2),
                _c("span", { staticClass: "con" }, [
                  _vm._v(
                    _vm._s(_vm._f("isEmpty")(_vm.studentInfo.profession_title))
                  ),
                ]),
              ]),
            ]),
            _c("div", [
              _c(
                "span",
                {
                  staticClass: "oringe-link mat10",
                  attrs: { to: "" },
                  on: {
                    click: function ($event) {
                      return _vm.jump(
                        _vm._ENTRANCETYPE == "adult"
                          ? "informationAE"
                          : "informationST"
                      )
                    },
                  },
                },
                [_vm._v("查看更多")]
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "teacher-info" }, [
          _c(
            "div",
            { staticClass: "teacher-head" },
            [
              _c(
                "el-image",
                {
                  staticStyle: {
                    width: "80px",
                    height: "80px",
                    "border-radius": "50%",
                  },
                  attrs: { src: _vm.studentInfo.teacher_thumb, fit: "cover" },
                },
                [
                  _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      slot: "error",
                      src: require("@/assets/images/headEmpty.png"),
                      alt: "暂无头像",
                    },
                    slot: "error",
                  }),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "teacher-content" }, [
            _vm._m(3),
            _c("p", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm._f("isEmpty")(_vm.studentInfo.teacher_title))),
            ]),
            _c("p", { staticClass: "phone" }, [
              _c("i", { staticClass: "icon3" }),
              _vm._v(
                " 联系电话：" +
                  _vm._s(_vm._f("isEmpty")(_vm.studentInfo.teacher_mobile)) +
                  " "
              ),
            ]),
          ]),
        ]),
      ]),
      _c(
        "el-row",
        { attrs: { gutter: 15 } },
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c("div", { staticClass: "item-box" }, [
              _c("div", { staticClass: "course-content" }, [
                _c("div", [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("已完成学时（40分钟=1学时）"),
                  ]),
                  _c("img", {
                    staticClass: "course-content-icon",
                    attrs: {
                      src: require("@/assets/images/complete1.png"),
                      alt: "",
                    },
                  }),
                  _c("p", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.majorProgress.learn_duration)),
                  ]),
                ]),
                _c(
                  "p",
                  [
                    _c("ComponentProgress", {
                      attrs: {
                        percentage:
                          _vm.percent(
                            _vm.majorProgress.learn_duration,
                            _vm.majorProgress.sum_duration
                          ) + "%",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("div", { staticClass: "item-box" }, [
              _c("div", { staticClass: "course-content" }, [
                _c("div", [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("已完成课程（门）"),
                  ]),
                  _c("img", {
                    staticClass: "course-content-icon",
                    attrs: {
                      src: require("@/assets/images/complete.png"),
                      alt: "",
                    },
                  }),
                  _c("p", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.majorProgress.complete_course)),
                  ]),
                ]),
                _c(
                  "p",
                  [
                    _c("ComponentProgress", {
                      attrs: {
                        percentage:
                          _vm.percent(
                            _vm.majorProgress.complete_course,
                            _vm.majorProgress.count_course
                          ) + "%",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { type: "flex", gutter: 15 } },
        [
          _c(
            "el-col",
            { staticStyle: { overflow: "hidden" }, attrs: { span: 8 } },
            [
              _c(
                "div",
                {
                  staticClass: "item-box2 zn-box",
                  staticStyle: { height: "100%" },
                },
                [
                  _c("em", { staticClass: "smartTitle" }),
                  _c("p", { staticClass: "uni-line-title" }, [
                    _c("span", { staticClass: "line" }),
                    _c("span", { staticClass: "span" }, [
                      _vm._v("海量题库，覆盖所有科目"),
                    ]),
                  ]),
                  _c("em", { staticClass: "smartImg" }),
                  _c(
                    "div",
                    {
                      staticClass: "zn-btn",
                      on: {
                        click: function ($event) {
                          return _vm.isRouter()
                        },
                      },
                    },
                    [_vm._v("开启智能练习")]
                  ),
                ]
              ),
            ]
          ),
          _c(
            "el-col",
            {
              staticStyle: { display: "flex", "flex-direction": "column" },
              attrs: { span: 16 },
            },
            [
              _c("div", { staticClass: "item-box2 study-content" }, [
                _c("p", { staticClass: "bold-title" }, [_vm._v("最近学习")]),
                _c(
                  "div",
                  { staticClass: "content-list" },
                  [
                    _vm._l(_vm.latestStudy, function (item) {
                      return _c(
                        "div",
                        { key: item.videoid, staticClass: "content" },
                        [
                          _c("p", { staticClass: "date" }, [
                            _c("i", { staticClass: "icon el-icon-time mar6" }),
                            _c("span", [_vm._v(_vm._s(item.created_at))]),
                          ]),
                          _c("div", { staticClass: "con" }, [
                            _c("span", { staticClass: "name" }, [
                              _vm._v(_vm._s(item.title)),
                            ]),
                            _c("div", { staticClass: "total" }, [
                              _c("span", [_vm._v("已学")]),
                              _c("span", { staticClass: "primary" }, [
                                _vm._v(_vm._s(_vm._f("persent")(item)) + "%"),
                              ]),
                              _c("span", [_vm._v("用时")]),
                              _c("span", { staticClass: "primary" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatSeconds")(item.long_node)
                                  )
                                ),
                              ]),
                            ]),
                            _c("span", { staticClass: "status" }, [
                              _vm._v(
                                _vm._s(item.learn_status == 1 ? "已完成" : "")
                              ),
                            ]),
                            _c(
                              "span",
                              {
                                staticClass: "uni-link-btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.jump("studyNotes", {
                                      course_id: item.course_id,
                                      lession_id: item.section_id,
                                    })
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "el-icon-video-play" }),
                                _vm._v(
                                  _vm._s(
                                    item.learn_status == 1
                                      ? "重新学习"
                                      : "继续学习"
                                  ) + " "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      )
                    }),
                    _vm.latestStudy.length == 0
                      ? _c("ComponentEmpty", {
                          staticStyle: { padding: "0" },
                          attrs: {
                            imgClass: "img-size",
                            title: "暂无最近的学习",
                            tips: "",
                          },
                        })
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
              _c("div", { staticClass: "item-box2 study-content" }, [
                _c("p", { staticClass: "bold-title" }, [_vm._v("最近练习")]),
                _c(
                  "div",
                  { staticClass: "content-list" },
                  [
                    _vm._l(_vm.latestPractice, function (item) {
                      return _c(
                        "div",
                        { key: item.id, staticClass: "content" },
                        [
                          _c("p", { staticClass: "date" }, [
                            _c("i", { staticClass: "icon el-icon-time mar6" }),
                            _c("span", [_vm._v(_vm._s(item.created_at))]),
                          ]),
                          _c("div", { staticClass: "con" }, [
                            _c("div", { staticClass: "name" }, [
                              _c("span", { staticClass: "uni-mark" }, [
                                _vm._v("[" + _vm._s(item.type_title) + "]"),
                              ]),
                              _vm._v(" " + _vm._s(item.title) + " "),
                            ]),
                            _c("div", { staticClass: "total" }, [
                              _c("i", { staticClass: "primary" }, [
                                _vm._v(_vm._s(item.subject_total || 0)),
                              ]),
                              _vm._v(" 题 / 对 "),
                              _c("i", { staticClass: "primary" }, [
                                _vm._v(_vm._s(item.correct_number || 0)),
                              ]),
                              _vm._v(" / 错 "),
                              _c("i", { staticClass: "primary" }, [
                                _vm._v(_vm._s(item.error_number || 0)),
                              ]),
                            ]),
                            _c(
                              "span",
                              {
                                staticClass: "uni-link-btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.isJump(item)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "el-icon-video-play" }),
                                _vm._v("继续练习 "),
                              ]
                            ),
                          ]),
                        ]
                      )
                    }),
                    _vm.latestPractice.length == 0
                      ? _c("ComponentEmpty", {
                          staticStyle: { padding: "0" },
                          attrs: {
                            imgClass: "img-size",
                            title: "暂无最近的练习",
                            tips: "",
                          },
                        })
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "tit" }, [
      _vm._v("姓"),
      _c("em", { staticClass: "mal28" }),
      _vm._v("名： "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "tit" }, [
      _vm._v("层"),
      _c("em", { staticClass: "mal28" }),
      _vm._v("次："),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "tit" }, [
      _vm._v("专"),
      _c("em", { staticClass: "mal28" }),
      _vm._v("业："),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "tit" }, [
      _c("span", [
        _vm._v(" 班主任信息 "),
        _c("i", { staticClass: "icon icon1" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }